import { matchPath } from 'react-router';

import { catchAll } from '@sorare/routing';

import { Sport } from '__generated__/globalTypes';
import { FOOTBALL, MLB, NBA } from 'constants/__generated__/routes';
import { STORAGE } from 'hooks/useLocalStorage';

export const sportFromCountry = (
  defaultSport?: Sport | null,
  defaultSportOnlyIfUS?: boolean
) => {
  const { sorareCountry = 'FR' } = document.documentElement.dataset;
  if (defaultSportOnlyIfUS) {
    return sorareCountry.toLowerCase() === 'us'
      ? defaultSport || Sport.NBA
      : Sport.FOOTBALL;
  }
  return (
    defaultSport ||
    (sorareCountry.toLowerCase() === 'us' ? Sport.NBA : Sport.FOOTBALL)
  );
};

const sportFromLocalStorage = (): Sport | undefined => {
  try {
    const storedSport = JSON.parse(localStorage.getItem(STORAGE.sport) ?? '');

    switch (storedSport) {
      case 'FOOTBALL':
        return Sport.FOOTBALL;
      case 'BASEBALL':
        return Sport.BASEBALL;
      case 'NBA':
        return Sport.NBA;
      default:
        return undefined;
    }
  } catch {
    return undefined;
  }
};

export const sportFromPath = (path: string) => {
  const mainSport = sportFromLocalStorage() || sportFromCountry();

  if (matchPath(catchAll(NBA), path)) {
    return Sport.NBA;
  }
  if (matchPath(catchAll(MLB), path)) {
    return Sport.BASEBALL;
  }
  if (matchPath(catchAll(FOOTBALL), path)) {
    return Sport.FOOTBALL;
  }
  return mainSport;
};
